<template lang="pug">
div
  v-snackbar(v-model="snackbar.visivel"
    :color="snackbar.cor"
    :right="$vuetify.breakpoint.mdAndUp"
    :top="$vuetify.breakpoint.mdAndUp"
    :bottom="$vuetify.breakpoint.smAndDown"
    :multi-line="$vuetify.breakpoint.smAndDown"
    :timeout="snackbar.tempo"
  ) {{ snackbar.mensagem }}
    v-btn(dark text @click="snackbar.visivel = false") Fechar

  toolbar-form-boletim(
    titulo='Novo Boletim'
    :exibe-botao-limpar="true"
    :exibe-loading-botao-salvar="loading"
    @evento-voltar="this.$router.go(-1)"
    @evento-limpar="limparForm"
    @evento-salvar="validar"
  )
  
  v-alert(:value="showMessageError" color="error" icon="warning" dismissible) {{messageError}}

  v-container
    v-form(enctype="multipart/form-data" ref="form")
      v-select(
        class="selecao"
        :items='tipos_lista'
        item-text='nome'
        item-value='id'
        v-model='boletim.tipo'
        data-vv-name="tipo"
        v-validate="'required'"
        label='Tipo'
        :error-messages="errors.first('tipo')"
      )
      v-text-field(type="number"
        :autofocus="true"
        v-model='boletim.numero'
        label='Número'
        data-vv-name="numero"
        v-validate="'required|integer'"
        :error-messages="errors.first('numero')"
      )
      v-menu(
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        full-width
        min-width="290px"
      )
        template(v-slot:activator="{ on }")
          v-text-field(
            v-model="dataFormatada"
            label="Data"
            prepend-icon="mdi-calendar"
            data-vv-name="data"
            v-validate="'required'"
            readonly
            :error-messages="errors.first('data')"
            v-on="on"
          )
        v-date-picker(v-model="boletim.data" no-title locale="pt-BR" @input="menu = false")

      v-file-input(label="Arquivo" 
        v-model="boletim.arquivo" 
        accept="pdf"
        v-validate="'required'"
        data-vv-name="arquivo"
        :error-messages="errors.first('arquivo')"
      )

      v-textarea(type="text" v-model='boletim.observacao' label='Observação (Opcional)' auto-grow)
</template>

<script>
export default {
  $_veeValidate: {
    validator: "new"
  },
  name: "boletins-create",
  computed: {
    dataFormatada() {
      return this.boletim.data
        ? this.$moment(this.boletim.data).format("DD/MM/YYYY")
        : "";
    },
    tipos_lista: function() {
      let list = [];

      for (let tipo of this.$store.state.tiposBoletins) {
        if (!this.$keycloak.hasResourceRole(tipo.id + "-admin", "intranet")) {
          continue;
        }

        list.push(tipo);
      }

      return list;
    }
  },
  data: () => ({
    loading: false,
    menu: false,
    boletim: {
      numero: null,
      data: null,
      arquivo: null,
      tipo: null
    },
    messageError: "",
    showMessageError: false,
    snackbar: {
      mensagem: "",
      visivel: false,
      cor: "",
      tempo: 3000
    }
  }),
  methods: {
    mensagemSucesso(mensagem) {
      this.snackbar.mensagem = mensagem
      this.snackbar.cor = "light-green darken-2"
      this.snackbar.visivel = true
    },
    mensagemError(mensagem) {
      this.snackbar.mensagem = mensagem
      this.snackbar.cor = "red darken-4"
      this.snackbar.visivel = true
    },
    mensagemInfo(mensagem) {
      this.snackbar.mensagem = mensagem
      this.snackbar.cor = "light-blue darken-4"
      this.snackbar.visivel = true
    },
    limparForm() {
      this.boletim = {
        numero: null,
        data: null,
        arquivo: null
      };

      this.$validator.reset();
    },
    validar() {
      this.$validator.validate().then(result => {
        if (result) {
          this.salvar()
        }
      })
    },
    async salvar() {
      this.loading = true
      const form   = new FormData()
      form.append("numero",  this.boletim.numero)
      form.append("data",    this.boletim.data)
      form.append("tipo",    this.boletim.tipo)
      form.append("arquivo", this.boletim.arquivo)

      const api  = this.$api('boletins')
      const tipo = this.$store.state.tiposBoletins.find(tipoBoletim => tipoBoletim.id == this.boletim.tipo)

      try{
        const response = await api.post(tipo.resource, form)
        this.mensagemSucesso("Boletim criado com sucesso")
        this.limparForm()
        this.loading = false
      }
      catch(error){
        let list = []
        let keys = Object.keys(error.response.data.errors)

        if (error.response.status == 422) {
          for (const campo of keys) {
            for (const mensagem of error.response.data.errors[campo]) {
              list.push(" - " + mensagem)
            }
          }
        }

        this.messageError = list.join("<br/>")
        this.showMessageError = true
        this.loading = false
      }
    }
  }
}
</script>
